import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import UndergradAdmissionApplication from '../../menforms/form/UndergraduateAppGTSU'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="GTSU Undergraduate Admissions Application || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="GTSU Undergraduate Admissions Application"
            subtitledown="GTSU Undergraduate Admissions Application"
           />
            <UndergradAdmissionApplication/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main